import {
    Button,
    checkAndSetError, CheckBoxField,
    clearInputFormErrorFields, convertInputFormToObject,
    InputForm, inputFormIsValid,
    TextField,
    useInputForm
} from "../../../Components/Inputs";
import {GridCell, gridConstants, GridContainer} from "../../../Components/Grid";
import React, {useEffect} from "react";
import {shippingLocationModel} from "./shippingLocationFactory";
import {SearchableSingleSelectField} from "../../../Components/Inputs/SearchableSingleSelectField";
import {createListFromArrayOfObjects} from "../../../Utilities/Types/listUtilities";
import {isFimcAdmin} from "../../../Utilities/LocalStorage/storageUtilities";
import {emptyGuid} from "../../../Utilities/commonUtilities";

interface ShippingLocationAddFormProps {
    handleReturn: () => void;
    handleSaveShippingLocation: (location: Record<string, unknown>) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    shippingLocations?: any;
}

export const ShippingLocationAddForm = ({
                                            handleReturn,
                                            handleSaveShippingLocation,
                                            shippingLocations,
                                        }: ShippingLocationAddFormProps) => {

    const shippingLocationForm = useInputForm(shippingLocationModel());

    const handleChangeShippingLocationId = (value: React.ChangeEvent<HTMLSelectElement>) => {
        shippingLocationForm.shippingLocationId.setValue(value.target.value);
    }

    const selectedShippingLocation = shippingLocations?.find((s: Record<string, any>) => s.shippingLocationId === shippingLocationForm.shippingLocationId.value);
    const isShippingLocationDisabled = String(shippingLocationForm.isEnabled.value).toLowerCase() === "false";

    const handleSaveClick = () => {

        clearInputFormErrorFields(shippingLocationForm);

        checkAndSetError([
            shippingLocationForm.name,
            shippingLocationForm.address,
            shippingLocationForm.city,
            shippingLocationForm.state,
            shippingLocationForm.zipcode,
        ]);

        if (inputFormIsValid(shippingLocationForm)) {
            const shippingLocation = convertInputFormToObject(shippingLocationForm);
            handleSaveShippingLocation(shippingLocation);
        }
    }

    useEffect(() => {
        if (selectedShippingLocation) {
            shippingLocationForm.name.setValue(selectedShippingLocation.name || ``);
            shippingLocationForm.address.setValue(selectedShippingLocation.address || ``);
            shippingLocationForm.address2.setValue(selectedShippingLocation.address2 || ``);
            shippingLocationForm.city.setValue(selectedShippingLocation.city || ``);
            shippingLocationForm.state.setValue(selectedShippingLocation.state || ``);
            shippingLocationForm.zipcode.setValue(selectedShippingLocation.zipCode || ``);
            shippingLocationForm.isEnabled.setValue(String(selectedShippingLocation.isEnabled ?? true));

        } else {
            shippingLocationForm.name.setValue(``);
            shippingLocationForm.address.setValue(``);
            shippingLocationForm.address2.setValue(``);
            shippingLocationForm.city.setValue(``);
            shippingLocationForm.state.setValue(``);
            shippingLocationForm.zipcode.setValue(``);
            shippingLocationForm.isEnabled.setValue("true");

        }

    }, [selectedShippingLocation]);

    return <>
        {
            isFimcAdmin() && (
                <GridContainer hasMarginY>
                        <SearchableSingleSelectField
                            {...shippingLocationForm.shippingLocationId}
                            medium_columns={gridConstants.column.TWELVE}
                            label={'Shipping Locations'}
                            options={createListFromArrayOfObjects(shippingLocations, `shippingLocationId`, `name`)}
                            onChange={handleChangeShippingLocationId}
                            defaultOption={"-- Create New Shipping Location --"}
                            defaultOptionValue={emptyGuid}
                            includeDefaultOption
                            value={shippingLocationForm.shippingLocationId?.value ?? ``}


                        />


                </GridContainer>
            )}

        <InputForm name={`shippingLocationForm`}>

            <TextField
                {...shippingLocationForm.name}
                label={`Location Short Description`}
                medium_columns={gridConstants.column.SIX}/>

            <TextField
                {...shippingLocationForm.address}
                medium_columns={gridConstants.column.SIX}/>

            <TextField
                {...shippingLocationForm.address2}
                label={`Address Line 2 (optional)`}
                medium_columns={gridConstants.column.SIX}/>

            <TextField
                {...shippingLocationForm.city}
                medium_columns={gridConstants.column.SIX}/>

            <TextField
                {...shippingLocationForm.state}
                medium_columns={gridConstants.column.SIX}/>

            <TextField
                {...shippingLocationForm.zipcode}
                medium_columns={gridConstants.column.SIX}/>


            {
                isFimcAdmin() && (
                    <CheckBoxField
                        name="isEnabled"
                        checked={isShippingLocationDisabled}
                        label={"Disable this Shipping Location for patrons"}
                        onChange={(e) => {
                            shippingLocationForm.isEnabled.setValue(String(!e.target.checked));
                        }}
                    />
                )
            }

            <GridCell className={`text-center`}>
                <Button
                    isPrimary isCollapsed
                    label={'Save'}
                    name={`btnSave`}
                    onClick={handleSaveClick}/>
                <Button
                    isCollapsed
                    label={'Cancel'}
                    name={`btnCancel`}
                    onClick={handleReturn}/>
            </GridCell>
        </InputForm>

    </>

};

